import { INVERT_COLOR_MAP } from '../config/constants';

type ColorMap = Record<string, string>;

export const normalizeColor = (color: string): string => color.trim().toLowerCase();

export const mapColor = (color: string, map: Record<string, string>): string => {
  const normalized = normalizeColor(color);
  return map[normalized] ?? color;
};

export const swapBlackWhite = (color: string): string => {
  const normalized = normalizeColor(color);
  if (normalized === '#000000' || normalized === '#000' || normalized === 'black') {
    return '#ffffff';
  }
  if (normalized === '#ffffff' || normalized === '#fff' || normalized === 'white') {
    return '#000000';
  }
  return color;
};

export const swapThemeColor = (
  color: string,
  themeMap?: ColorMap,
  invertMap: ColorMap = INVERT_COLOR_MAP
): string => {
  if (themeMap) {
    const mapped = themeMap[normalizeColor(color)];
    if (mapped) {
      return mapped;
    }
  }
  return mapColor(color, invertMap);
};

export const swapTextColor = (
  color: string,
  themeMap?: ColorMap,
  invertMap: ColorMap = INVERT_COLOR_MAP
): string => {
  const swapped = swapBlackWhite(color);
  if (swapped !== color) {
    return swapped;
  }
  return swapThemeColor(color, themeMap, invertMap);
};
